import React from 'react';

import { Category } from 'ha/components/Filters/utils/getTagList';
import FiltersTags from 'ha/components/Filters/FiltersTags';
import { SearchFiltersContext } from 'ha/pages/Search/SearchFiltersContext';
import { RadiusValue, SearchAreaValue } from 'ha/types/SearchFilters';

const SearchFiltersTags: React.FC = () => {
  const {
    localState,
    onChangeBills,
    onChangeDates,
    onChangeFurniture,
    onChangeGender,
    onChangePrice,
    onChangeRecentlyAdded,
    onChangeRegistration,
    onChangeRooms,
    onChangeRules,
    onChangeSuitableFor,
    onChangeTypes,
    onChangeSearchAreaFilter,
    onChangePropertySize,
    onChangeFacilities,
    onChangeAmenities,
    onChangeRadius,
  } = React.useContext(SearchFiltersContext);

  const handleRemove = React.useCallback(
    (filter: Category, removedValue?: string) => {
      if (filter === 'bills') {
        onChangeBills(localState.bills.filter(value => value !== removedValue));
      }
      if (filter === 'furniture') {
        onChangeFurniture(
          localState.furniture.filter(value => value !== removedValue),
        );
      }
      if (filter === 'gender') {
        onChangeGender(
          localState.gender.filter(value => value !== removedValue),
        );
      }
      if (filter === 'recentlyAdded') {
        onChangeRecentlyAdded(null);
      }
      if (filter === 'registration') {
        onChangeRegistration(
          localState.registration.filter(value => value !== removedValue),
        );
      }
      if (filter === 'rules') {
        onChangeRules(localState.rules.filter(value => value !== removedValue));
      }
      if (filter === 'suitableFor') {
        onChangeSuitableFor(
          localState.suitableFor.filter(value => value !== removedValue),
        );
      }
      if (filter === 'type') {
        onChangeTypes(localState.types.filter(value => value !== removedValue));
      }
      if (filter === 'bedroomCount') {
        onChangeRooms({
          bedroomCount: localState.rooms.bedroomCount.filter(
            value => value !== removedValue,
          ),
        });
      }
      if (filter === 'searchArea') {
        onChangeSearchAreaFilter([SearchAreaValue.CityBounds]);
      }
      if (filter === 'dates') {
        onChangeDates({ startDate: null, endDate: null });
      }
      if (filter === 'price') {
        onChangePrice({ min: null, max: null });
      }
      if (filter === 'propertySize') {
        onChangePropertySize({});
      }
      if (filter === 'facilities') {
        onChangeFacilities(
          localState.facilities.filter(value => value !== removedValue),
        );
      }
      if (filter === 'amenities') {
        onChangeAmenities(
          localState.amenities.filter(value => value !== removedValue),
        );
      }
      if (filter === 'radius') {
        onChangeRadius(RadiusValue.DEFAULT);
      }
    },
    [
      localState,
      onChangeBills,
      onChangeDates,
      onChangeFurniture,
      onChangeGender,
      onChangePrice,
      onChangeRecentlyAdded,
      onChangeRegistration,
      onChangeRooms,
      onChangeRules,
      onChangeSuitableFor,
      onChangeTypes,
      onChangeSearchAreaFilter,
      onChangePropertySize,
      onChangeFacilities,
      onChangeAmenities,
      onChangeRadius,
    ],
  );

  return (
    <FiltersTags
      types={localState.types}
      furniture={localState.furniture}
      bills={localState.bills}
      registration={localState.registration}
      suitableFor={localState.suitableFor}
      recentlyAdded={localState.recentlyAdded}
      rules={localState.rules}
      gender={localState.gender}
      rooms={localState.rooms}
      price={localState.price}
      dates={localState.dates}
      searchArea={localState.searchArea}
      propertySize={localState.propertySize}
      facilities={localState.facilities}
      amenities={localState.amenities}
      radius={localState.radius}
      onRemove={handleRemove}
    />
  );
};

export default SearchFiltersTags;
